import { useEffect, useRef, useSyncExternalStore } from "react";

// Pinnable toggles (SegmentedControls) on screen. Fav Toggles only shows when there's one,
// and the mobile chip sheets borrow the matching desktop control's pin handler.
let count = 0;
const subs = new Set();
const live = new Set();
const emit = () => subs.forEach((f) => f());
export function useRegisterSeg(info) {
    const ref = useRef(info || {});
    ref.current = info || {};
    useEffect(() => { count += 1; live.add(ref); emit(); return () => { count -= 1; live.delete(ref); emit(); }; }, []);
}
export const useHasSegs = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => count > 0);
// Same option keys (prefer the one currently on the same value) and pinnable.
export function findSegFor(keys, value) {
    const want = [...keys].sort().join("|");
    const hits = [...live].map((r) => r.current).filter((c) => c.onPin && c.keys && [...c.keys].sort().join("|") === want);
    return hits.find((c) => c.value === value) || hits[0] || null;
}
